import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LoadingController, NavParams } from 'ionic-angular';
import { TournamentService } from '../../../../services/tournament.service';

@Component({
  selector: 'result-me-ko-table',
  templateUrl: 'result-me-ko-table.html',
})
export class ResultMeKoTablePage {
  gamePlanList: IGamePlan[] = [];
  numerators = [];

  @Input() activePlan: any;
  @Input() header: boolean = true;

  @Output() onEdit = new EventEmitter<any>();

  constructor(
    private navParams: NavParams,
    public gs: TournamentService,
    public loadCtrl: LoadingController
  ) { 
    let loader = this.loadCtrl.create({});
    loader.present();
    setTimeout(() => {
      this.getNumerator();
      loader.dismiss();
    }, 300);
  }

  getNumerator() {
    let id = 1;
    for (let i = 0; i < this.gs.planList[this.activePlan].roundGameTable.length; i++) {
      let table = [];
      for (let j = 0; j < this.gs.planList[this.activePlan].roundGameTable[i].length; j++) {
        table.push(id);
        id += 1;
      }
      this.numerators.push(table);
    }
  }

  onEditTeam(i: number, j: number) {
    this.onEdit.emit({ i: i, j: j, graph: true });
  }
}



export interface IGamePlan {
  id: number;
  gameDay: number;
  name: string;
  team1: {
    id: number;
    name: string;
  };
  team2: {
    id: number;
    name: string;
  }
}






// WEBPACK FOOTER //
// /src/pages/apps/gamer/pages/results/result-me-ko/map-game-table/result-me-ko-table.ts